<template>
    <div>
        <v-sheet
            style="
                position: absolute;
                width: 344px;
                height: 100vh;
                z-index: 999;
                left: 0;
                background-color: transparent;
            "
            class="d-flex flex-column justify-center mx-3 align-center errorBox"
        >
            <v-sheet
                style="position: absolute; width: 344px; height: 476px; z-index: 999; left: 0; opacity: 0.7"
                color="white"
            ></v-sheet>
            <v-btn style="z-index: 1000; font-size: 12px" disabled depressed>
                ingen uppkoppling
            </v-btn>
        </v-sheet>
    </div>
</template>

<script>
    export default {};
</script>

<style lang="scss" scoped></style>
